module.exports = __webpack_public_path__ + "static/media/logo.cdadb5d4.png";